module.exports = __webpack_public_path__ + "img/17.818b63d4.svg";